import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Subscription } from 'src/app/azurefunctions/azure-functions.service';


@Component({
    selector: 'sc-subscription-chooser-modal',
    templateUrl: './subscription-chooser-modal.component.html',
    styleUrls: ['./subscription-chooser-modal.component.css']
  })
  export class SubscriptionChooserModal implements OnInit {
    
    @ViewChild("dialog", {static: false}) private dialogRef: ElementRef;
    @ViewChild("selector", {static: false}) private selectorRef: ElementRef;
    

    dialogPromise: Promise<Subscription>;
    subcriptions: Subscription[];
    selectedSubscriptionsId: string[] = [];
    showSubscriptionChooser: boolean;
    private resolve: any;
    private reject: any;
    /**
     *
     */
    constructor() {
        this.dialogPromise = new Promise<Subscription>((resolve, reject) =>{
            this.resolve = resolve;
            this.reject = reject;
        });
        
    }

    ngOnInit(): void {
        
    }

    open(subscripitons: Subscription[]): Promise<Subscription>{
        this.showSubscriptionChooser = true;
        this.subcriptions = subscripitons;
        return this.dialogPromise;
    }

    private resolveDialog(subscription: Subscription){
        this.showSubscriptionChooser = false;
        this.resolve(subscription);
    }

    private rejectDialog(error: any){
        this.showSubscriptionChooser = false;
        this.reject(error);
    }

    okPressed(){
        var value = this.selectorRef.nativeElement.value;
        if(!value || value.length != 1){
            this.selectorRef.nativeElement.valid = false;
            //this.selectorRef.nativeElement.valid = false;
            return;
        }

        var currentSubsId = value[0];
        var currentSubs = this.subcriptions.filter((s) => s.subscriptionId == currentSubsId);
        if(currentSubs.length == 1){
            this.resolveDialog(currentSubs[0]);
        }

    }

    cancelPressed(){
        this.rejectDialog("Cancelled by user");
    }
    
  }